// Profile-color helper - generates a deterministic HSL color from a name string.
//
// Mirrors EXACTLY the backend logic in src/backend_routes/Employee_server.js
// (generateColorFromText). Keep these in sync - the whole point is that the
// avatar circle in the left navbar (server-supplied profile_color) and any
// circle rendered client-side from a name (this util) produce the SAME color
// for the same employee.
//
// Lightness locked at 60% guarantees white text on the circle stays readable
// regardless of which hue lands.
export function profileColorFromName(name) {
    const text = String(name || "").trim() || "User";
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
        hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash % 360);
    return `hsl(${hue}, 70%, 60%)`;
}

// Convenience: returns up to two-letter initials from a "First Last" pair.
// Falls back gracefully when one or both names are missing.
export function initialsFromName(first, last) {
    const a = String(first || "").trim().charAt(0).toUpperCase();
    const b = String(last  || "").trim().charAt(0).toUpperCase();
    return (a + b) || "?";
}
